<template>
  <div>
    <v-navigation-drawer
      v-if="!callActive"
      v-model="drawer"
      fixed
      app
      width="300"
    >
      <v-toolbar flat>
        <v-list>
          <v-list-item>
            <v-list-item-title class="text-h6">
              Store Space
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-toolbar>
      <v-list dense>
        <div v-for="item in items" :key="item.id">
          <navigation-drawer-item
            :data-testid="`${item.id}`"
            :class="`${item.id}`"
            v-if="item.type === 'item'"
            :icon="item.icon"
            :title="item.title"
            :route_to="item.route_to"
            :roles="item.roles"
          />
          <navigation-drawer-list
            :data-testid="`${item.id}`"
            :class="`${item.id}`"
            v-if="item.type === 'list'"
            :icon="item.icon"
            :title="item.title"
            :items="item.items"
            :roles="item.roles"
          />
        </div>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import NavigationDrawerItem from "@/components/NavigationDrawerItem";
import NavigationDrawerList from "@/components/NavigationDrawerList";
import { mapGetters } from "vuex";
import navigationRoles from "@/helpers/navigation-roles";

export default {
  data() {
    return {
      startItems: navigationRoles
    };
  },
  components: {
    NavigationDrawerItem,
    NavigationDrawerList
  },
  props: {
    roles: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: "isAdmin"
    }),
    callActive() {
      return localStorage.getItem("callStarted");
    },
    items() {
      return this.startItems.filter(item => {
        return item.roles.find(role => this.roles.find(item => item === role));
      });
    },
    drawer: {
      get() {
        return this.$store.state.application.settings.drawer;
      },
      set(newValue) {
        this.$store.dispatch("toggleDrawer", newValue);
      }
    }
  }
};
</script>
